import { createSlice } from '@reduxjs/toolkit';

const deletedImageSlice = createSlice({
  name: "deletedImage",
  initialState: { deletedImages: [] },
  reducers: {
    deletedImagesAdd(state, action) {
      state.deletedImages.push(action.payload);
    },
    resetDeletedImages(state) {
      state.deletedImages = [];
    },
  },
});

export const { deletedImagesAdd, resetDeletedImages } = deletedImageSlice.actions;
export default deletedImageSlice.reducer;
